export default __webpack_public_path__ + "static/media/pinkMobile.d51ee76f.png";